let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kdgSW")).then(() => parcelRequire('8fJ1g'));